/*
// Example usage:
sendGA4Event("search_page_load", {
    searchQuery: new URLSearchParams(window.location.search).get("q"),
});
*/

/**
 * Standardizes the sending of events to GA4.
 * @param {string} eventName - The name of the event.
 * @param {Object} eventDetails - An object containing the event details.
 */
function sendGA4Event(eventName, eventDetails = {}) {
    console.log("GA4 Event:", eventName, eventDetails);
    eventDetails.usertype      = window.ga4LogState?.userId ? "Registered" : "Guest";
    eventDetails.signin_status = window.ga4LogState?.logState || "Unknown";
    eventDetails.timestamp     = new Date().toISOString();
    eventDetails.pagename      = window.location.pathname;

    document.dispatchEvent(new CustomEvent(eventName, {
        detail: eventDetails,
    }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...eventDetails
    });
}

/**
 * Reports a menu click event to GA4.
 * @param {Object} link - The link object passed from Liquid.
 */
function reportMenuClick(link) {
    sendGA4Event("nav_bar_tapped", link);
}